import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import Backend from 'i18next-http-backend';

const isProd = process.env.NODE_ENV === 'production';

i18n.use(initReactI18next).use(Backend).init({
  debug: !isProd,
  lng: 'en',
  fallbackLng: 'en',
  saveMissing: !isProd,
});
export default i18n;
